import { Box, Divider, IconButton, styled, Typography } from '@mui/material';
import { IconCross, IconInbox, IconUser } from 'assets/img';
import { getFullNameWithInfix } from 'hq/components/views/flexWorkers/utils';
import { SignDocumentHeaderProps } from './sign-document-dialog-header.types';

export const SignDocumentDialogHeader = ({
  onClose,
  firstName,
  lastName,
  infix,
  email,
  documentName,
  documentType,
}: SignDocumentHeaderProps) => {
  return (
    <Box margin={'20px'}>
      <HeaderWrapper>
        <FlexRowBoxSpaceBetween role="fw-profile">
          <FlexColumnEnd>
            <Typography variant="h3" fontWeight={500}>
              {documentName}
            </Typography>
            <Typography variant="subtitle1">{documentType}</Typography>
          </FlexColumnEnd>
          <Box display="flex" flexDirection="row">
            <IconButton onClick={onClose}>
              <IconCross width={24} height={24} />
            </IconButton>
          </Box>
        </FlexRowBoxSpaceBetween>

        <InfoWrap>
          <WorkerInfoWrap>
            <Box display="flex" flexDirection="row" gap="8px">
              <StyledIcon width={24} height={24} as={IconUser} />
              <CredentialText paddingRight={5} noWrap>
                {getFullNameWithInfix({ firstName, infix, lastName })}
              </CredentialText>
            </Box>
            <Box display="flex" flexDirection="row" gap="8px">
              <StyledIcon width={24} height={24} as={IconInbox} />
              <CredentialText paddingRight={5} noWrap>
                {email}
              </CredentialText>
            </Box>
          </WorkerInfoWrap>
        </InfoWrap>
      </HeaderWrapper>
      <Divider />
    </Box>
  );
};

const FlexRowBoxSpaceBetween = styled(Box)(({ theme }) => ({
  alignItems: 'flex-start',
  minWidth: 0,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: '0.5rem',
  marginBottom: theme.spacing(2),
}));

const WorkerInfoWrap = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '0.25rem',
  alignItems: 'flex-end',
}));

const HeaderWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  marginBottom: theme.spacing(3),
}));

const CredentialText = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  fontWeight: 500,
  marginLeft: theme.spacing(1),
  opacity: '0.6',
}));

const FlexColumnEnd = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-end',
  cursor: 'default',
  gap: '0.25rem',
}));

const InfoWrap = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-end',
  gap: '1.5rem',
  cursor: 'default',
}));

const StyledIcon = styled('svg')(() => ({
  marginLeft: '-4px',
  '& path': {
    stroke: 'rgba(0, 0, 0, 0.4)',
  },
}));
